export const Routes = {
    Home: '/',
    About: '/about',
    Support: '/support',
};